<template>
    <v-card outlined>
        <div>
            <v-card-title
                class="subtitle-3 d-flex"
                style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap;"
            >
                <v-btn
                    class="text-capitalize"
                    depressed
                    elevation="8"
                    fab
                    dark
                    @click="goToPrevStep()"
                >
                    <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
                </v-btn>

                <span class="text-h4 pl-5 pr-5">{{
                    newCampaign.category && translations.titleStep3[lang]
                }}</span>

                <v-btn
                    class="text-capitalize"
                    depressed
                    :elevation="(canGoToNextStep && !this.loading && 8) || 0"
                    dark
                    fab
                    :disabled="!canGoToNextStep || loading"
                    @click="goToNextStep()"
                >
                    <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="text--primary pt-5">
                <v-row class="flex-column justify-center align-center">

                    <v-card-text class="text--primary pt-5">
                        <v-row
                            v-if="
                                !campaignConditions ||
                                    !campaignConditions.length
                            "
                            class="d-flex justify-center transition-all mw-100"
                        >
                            <v-col
                                v-for="(item, index) in [1, 2, 3, 4, 5, 6]"
                                :key="index"
                                cols="12"
                                sm="12"
                                md="4"
                                class="rounded-xl d-flex flex-column justify-center align-center ma-2 mt-0 pa-2  rounded"
                            >
                                <v-skeleton-loader
                                    class="d-flex justify-center transition-all mw-100 campaign-actions conditions-loader"
                                    :types="{ actions: 'button@1' }"
                                    type="actions"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-row>

                        <v-row
                            v-else
                            class="d-flex justify-center transition-all mw-100"
                        >
                            <v-col
                                v-for="(item, index) in conditionsWithTranslations"
                                :key="index"
                                cols="12"
                                sm="12"
                                md="4"
                                class="rounded-xl d-flex flex-column justify-center align-center ma-2 mt-0 pa-10 pt-2 pb-2 select-category transition-all border-grey text-subtitle-2 rounded text-center"
                                :class="[
                                    newCampaign.campaign_condition_id ==
                                        item.campaign_condition_id &&
                                        'selected-condition'
                                ]"
                                @click="attachCondition(item)"
                            >
                                {{
                                    translations[`${item.system}Condition`][
                                        lang
                                    ]
                                }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <div
                    v-show="selectedCondition.options"
                        ref="conditions"
                        id="conditions"
                        style="min-height: 200px; max-width: 700px; width: 100%"
                    >
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="d-flex flex-column"
                            v-if="selectedCondition && selectedCondition.system"
                        >
                            <v-row
                                v-if="
                                    selectedCondition.options.lat !== undefined
                                "
                            >
                                <v-col cols="12" sm="12" md="9">
                                    <Places
                                        :label="translations.address[lang]"
                                        class="mt-3 mb-4"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        :initial-address="address"
                                        @newAddress="setAddressDetails"
                                        :clearable="false"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <b-text-field
                                        v-model="radius"
                                        :label="translations.radius[lang]"
                                        type="number"
                                    ></b-text-field>
                                </v-col>
                            </v-row>
                            <gmap-map
                                :center="center"
                                :zoom="12"
                                style="width: 100%; height: 400px"
                                v-if="
                                    selectedCondition.system ==
                                        'based_on_location'
                                "
                            >
                                <gmap-marker
                                    :key="index"
                                    v-for="(m, index) in markers"
                                    :position="m.position"
                                    @click="() => (center = m.position)"
                                ></gmap-marker>

                                <GmapCircle
                                    v-for="(pin, index) in markers"
                                    :key="index + 1"
                                    :center="pin.position"
                                    :radius="Number(radius * 1000)"
                                    :visible="true"
                                    :options="{
                                        strokeColor: '#2596bea8',
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: '#2596bea8',
                                        fillOpacity: 0.35
                                    }"
                                ></GmapCircle>
                            </gmap-map>
                            <!-- </v-col> -->

                            <v-col
                                v-if="
                                   selectedCondition.options.transaction_type_ids !== undefined
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.transactionTypes[lang]
                                        }}</span>
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col
                                        v-for="(item,
                                        index) in transactionTypes.filter(t => t.type=='order')"
                                        :key="index"
                                        cols="12"
                                        sm="12"
                                        md="2"
                                        class=" d-flex flex-column justify-center align-center ma-2 mt-0 pa-2 pt-2 pb-0 select-transaction-type transition-all text-subtitle-2 rounded-lg text-center"
                                        :class="[
                                            selectedCondition.options.transaction_type_ids.includes(
                                                item.transaction_type_id
                                            ) && 'selected-condition'
                                        ]"
                                        @click="
                                            selectTransactionType(
                                                item,
                                                selectedCondition.options
                                                    .transaction_type_ids
                                            )
                                        "
                                    >
                                        <v-sheet
                                            class=" rounded-circle pa-1 text-center pr-0 pl-0 mw-100 text-subtitle-2 border-grey"
                                        >
                                            <v-icon
                                                class="ma-3 text-subtitle-1"
                                                size="65"
                                                v-text="
                                                    transactionTypesIcons[
                                                        item.transaction_type_id
                                                    ]
                                                "
                                            ></v-icon>
                                        </v-sheet>
                                        <div
                                            class=" text-center pr-0 pl-0 mw-100 text-body-2 d-flex align-center"
                                            style="min-height:75px"
                                        >
                                            {{ item.name }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-autocomplete
                            v-if="
                                   selectedCondition.options.store_ids !== undefined
                                "
                                prepend-inner-icon="mdi-store"
                                :items="storesData"
                                v-model="selectedStores"
                                item-text="name"
                                item-value="store_id"
                                menu-props="offsetY"
                                :label="translations.stores[lang]"
                                class="mt-4"
                                outlined
                                dense
                                hide-details
                                clearable
                                multiple
                                :search-input.sync="search"
                                :loading="loading"
                                :disable-lookup="true"
                                item-disabled="disable"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-if="selectedStores.length < 5"
                                        v-bind="data.attrs"
                                        close
                                        small
                                        class="mt-1"
                                        @click:close="removeSelectedStore(data)"
                                    >
                                        {{ data.item.name }}
                                    </v-chip>
                                    <div v-else-if="data.index === 0">
                                        {{
                                            (allStoresAreSelected &&
                                                translations.all[lang]) ||
                                                `${selectedStores.length} ` +
                                                    translations.storesSelected[
                                                        lang
                                                    ]
                                        }}
                                    </div>
                                </template>
                                <template v-slot:prepend-item>
                                    <v-list-item ripple style="cursor: pointer" @click="toggleSelectAllStores">
                                        <v-checkbox
                                            @click.stop.prevent="toggleSelectAllStores"
                                                        v-model="
                                                            allStoresAreSelected
                                                        "
                                                        readonly
                                                        class="ml-0 mt-0 mb-n3 transition-all"
                                                        color="secondary"
                                                    >
                                                    </v-checkbox>
                                        <v-list-item-action class="ml-6">
                                        
                                            {{ translations.all[lang] }}
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>

                                <template v-slot:append-item>
                                    <div v-intersect="endIntersectStores"></div>
                                    <v-list-item v-if="loading">
                                        <v-list-item-action class="ml-1">
                                            <v-row class="d-flex align-center">
                                                <v-btn
                                                    class="text-capitalize"
                                                    depressed
                                                    fab
                                                    small
                                                    :loading="true"
                                                    style="background: transparent"
                                                >
                                                </v-btn>
                                                <span class="pa-2">{{
                                                    translations.loadMore[lang]
                                                }}</span>
                                            </v-row>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>

                            <v-autocomplete
                                v-if="selectedCondition.options.store_id !== undefined"
                                prepend-inner-icon="mdi-store"
                                :items="storesData"
                                v-model="selectedStores[0]"
                                item-text="name"
                                item-value="store_id"
                                menu-props="offsetY"
                                :label="translations.store[lang]"
                                class="mt-4"
                                outlined
                                dense
                                hide-details
                                clearable
                                :search-input.sync="search"
                                :loading="loading"
                                :disable-lookup="true"
                                item-disabled="disable"
                            >
                                <!-- <template v-slot:selection="data">
                                    <v-chip
                                        v-bind="data.attrs"
                                        close
                                        small
                                        class="mt-1"
                                        @click:close="removeSelectedStore(data)"
                                    >
                                        {{ data.item.name }}
                                    </v-chip>
                                </template> -->
                                <template v-slot:append-item>
                                    <div v-intersect="endIntersectStores"></div>
                                    <v-list-item v-if="loading">
                                        <v-list-item-action class="ml-1">
                                            <v-row class="d-flex align-center">
                                                <v-btn
                                                    class="text-capitalize"
                                                    depressed
                                                    fab
                                                    small
                                                    :loading="true"
                                                    style="background: transparent"
                                                >
                                                </v-btn>
                                                <span class="pa-2">{{
                                                    translations.loadMore[lang]
                                                }}</span>
                                            </v-row>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                            <v-row
                            v-if="
                                   selectedCondition.options.period !== undefined
                                "
                                class="mt-1"
                            >
                                <v-col cols="12" lg="6">
                                    <v-menu
                                        v-model="fromDateMenu"
                                        :close-on-content-click="false"
                                        max-width="290"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                :value="
                                                    localizeDate(
                                                        selectedCondition
                                                            .options.period
                                                            .from_date
                                                    )
                                                "
                                                clearable
                                                outlined
                                                dense
                                                :label="
                                                    translations.from[lang] +
                                                        translations.date[lang]
                                                "
                                                hide-details="auto"
                                                readonly
                                                prepend-inner-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click:clear="
                                                    selectedCondition.options.period.from_date =
                                                        ''
                                                "
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            dark
                                            v-model="
                                                selectedCondition.options.period
                                                    .from_date
                                            "
                                            :locale="locale"
                                            @change="fromDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" lg="6">
                                    <v-menu
                                        v-model="toDateMenu"
                                        :close-on-content-click="false"
                                        max-width="290"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                :value="
                                                    localizeDate(
                                                        selectedCondition
                                                            .options.period
                                                            .to_date
                                                    )
                                                "
                                                clearable
                                                :label="
                                                    translations.to[lang] +
                                                        translations.date[lang]
                                                "
                                                hide-details="auto"
                                                readonly
                                                prepend-inner-icon="mdi-calendar"
                                                outlined
                                                dense
                                                v-bind="attrs"
                                                v-on="on"
                                                @click:clear="
                                                    selectedCondition.options.period.to_date =
                                                        ''
                                                "
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            dark
                                            v-model="
                                                selectedCondition.options.period
                                                    .to_date
                                            "
                                            :locale="locale"
                                            @change="toDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <v-autocomplete
                            v-if="
                                   selectedCondition.options.product_ids !== undefined
                                "
                                v-model="selectedCondition.options.product_ids"
                                :items="products"
                                :item-text="'name[' + lang + ']'"
                                item-value="product_id"
                                menu-props="offsetY"
                                :label="translations.products[lang]"
                                class="mt-4"
                                outlined
                                prepend-inner-icon="mdi-package-variant-closed"
                                dense
                                multiple
                                hide-details
                                :search-input.sync="searchProducts"
                                :loading="loading"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-if="
                                            selectedCondition.options
                                                .product_ids.length < 5
                                        "
                                        v-bind="data.attrs"
                                        small
                                        class="mt-1"
                                    >
                                        {{ data.item.name[lang] }}
                                    </v-chip>
                                    <div v-else-if="data.index === 0">
                                        {{
                                            `${selectedCondition.options.product_ids.length} ` +
                                                translations.productsSelected[
                                                    lang
                                                ]
                                        }}
                                    </div>
                                </template>
                                <template v-slot:append-item>
                                    <div
                                        v-intersect="endIntersectProducts"
                                    ></div>
                                    <v-list-item v-if="loading">
                                        <v-list-item-action class="ml-1">
                                            <v-row class="d-flex align-center">
                                                <v-btn
                                                    class="text-capitalize"
                                                    depressed
                                                    fab
                                                    small
                                                    :loading="true"
                                                    style="background: transparent"
                                                >
                                                </v-btn>
                                                <span class="pa-2">{{
                                                    translations.loadMore[lang]
                                                }}</span>
                                            </v-row>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>

                            <v-autocomplete
                            v-if="
                                   selectedCondition.options.coupon_ids !== undefined
                                "
                                v-model="selectedCondition.options.coupon_ids"
                                :items="coupons"
                                item-text="gift_title"
                                item-value="gift_id"
                                menu-props="offsetY"
                                :label="translations.coupon[lang]"
                                class="mt-4"
                                outlined
                                prepend-inner-icon="mdi-ticket-percent"
                                dense
                                multiple
                                hide-details
                                :search-input.sync="searchCoupons"
                                :loading="loading"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-if="
                                            selectedCondition.options.coupon_ids
                                                .length < 5
                                        "
                                        v-bind="data.attrs"
                                        small
                                        class="mt-1"
                                    >
                                        {{ data.item.gift_title }}
                                    </v-chip>
                                    <div v-else-if="data.index === 0">
                                        {{
                                            `${selectedCondition.options.coupon_ids.length} ` +
                                                translations.couponsSelected[
                                                    lang
                                                ]
                                        }}
                                    </div>
                                </template>
                            </v-autocomplete>

                            <div class="d-flex flex-row">
                                <v-col
                                v-if="
                                   selectedCondition.options
                                   .number_of_transactions_after_campaign !== undefined
                                "
                                    cols="12"
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    class="pa-0 ma-0"
                                >
                                    <b-text-field
                                        v-model="
                                            selectedCondition.options
                                                .number_of_transactions_after_campaign
                                        "
                                        :label="
                                            translations
                                                .transactionsAfterCampaignCreation[
                                                lang
                                            ]
                                        "
                                        type="number"
                                        class="pr-1"
                                    ></b-text-field>
                                </v-col>
                                <v-col
                                v-if="
                                   selectedCondition.options.min_amount !== undefined
                                "
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    class="pa-0 ma-0"
                                >
                                  <b-text-field
                                      v-model="
                                              selectedCondition.options.min_amount
                                          "
                                      :label="
                                              translations.minAmountSpent[lang]
                                          "
                                      prepend-inner-icon="mdi-currency-eur"
                                      type="number"
                                      :class="[selectedCondition.options.number_of_transactions_after_campaign !== undefined ? 'pl-1' : 'pr-3']"
                                  ></b-text-field>
                                </v-col>
                            </div>
                            <div
                                v-if="
                                    ['from_older_campaign'].includes(
                                        selectedCondition.system
                                    ) && campaigns.length !== undefined
                                "
                                class="transition-all"
                            >
                                <v-col
                                    v-for="(item,
                                    index) in selectedCondition.options"
                                    :key="index"
                                    class="d-flex flex-column justify-space-between align-center transition-all"
                                >
                                    <v-divider
                                        v-if="index"
                                        style="width: 100%;"
                                    ></v-divider>
                                    <v-autocomplete
                                        v-if="!item.campaign_id"
                                        v-model="item.campaign_id"
                                        :items="remainingCampaigns"
                                        :item-text="oldCampaignItemText"
                                        item-value="campaign_id"
                                        menu-props="offsetY"
                                        :label="translations.campaign[lang]"
                                        class="pr-1 mt-3"
                                        outlined
                                        prepend-inner-icon="mdi-bullhorn"
                                        dense
                                        clearable
                                        hide-details
                                        :search-input.sync="searchCampaigns"
                                        :loading="loading"
                                        style="width:100%; max-width:600px"
                                        @change="saveCampaignData(index, item)"
                                    >
                                        <template v-slot:append-item>
                                            <div
                                                v-intersect="
                                                    endIntersectCampaigns
                                                "
                                            ></div>
                                            <v-list-item v-if="loading">
                                                <v-list-item-action
                                                    class="ml-1 text-subtitle-2"
                                                >
                                                    <v-row
                                                        class="d-flex align-center"
                                                    >
                                                        <v-btn
                                                            class="text-capitalize"
                                                            depressed
                                                            fab
                                                            small
                                                            :loading="true"
                                                            style="background: transparent"
                                                        >
                                                        </v-btn>
                                                        <span class="pa-2">{{
                                                            translations
                                                                .loadMore[lang]
                                                        }}</span>
                                                    </v-row>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                    <div
                                        class="d-flex mw-100 align-center"
                                        v-else
                                    >
                                        <v-text-field
                                            class="pr-1 mt-3"
                                            :class="'mr-auto'"
                                            :value="getCampaignData(item)"
                                            label=""
                                            hide-details
                                            prepend-icon="mdi-bullhorn"
                                            append-icon="mdi-close-circle"
                                            readonly
                                            full-width
                                            single-line
                                            outlined
                                            dense
                                            @click:append="
                                                clearCampaignIdOnNull(
                                                    item,
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </div>
                                    <div
                                        class="d-flex flex-column justify-space-between align-center transition-all mw-100"
                                        :class="[
                                            !item.campaign_id && 'invisible'
                                        ]"
                                    >
                                        <v-row
                                            class="d-flex justify-space-around align-center pt-4 mw-100"
                                        >
                                            <v-col cols="8" lg="6" class="pl-0 pr-1">
                                                <v-menu
                                                    v-model="fromDateMenu"
                                                    :close-on-content-click="
                                                        false
                                                    "
                                                    max-width="290"
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                    >
                                                        <v-text-field
                                                            :value="
                                                                localizeDate(
                                                                    item.from_date
                                                                )
                                                            "
                                                            clearable
                                                            outlined
                                                            dense
                                                            :label="
                                                                translations
                                                                    .from[
                                                                    lang
                                                                ] +
                                                                    translations
                                                                        .date[
                                                                        lang
                                                                    ]
                                                            "
                                                            hide-details="auto"
                                                            readonly
                                                            prepend-inner-icon="mdi-calendar"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="
                                                                item.from_date =
                                                                    ''
                                                            "
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        dark
                                                        v-model="item.from_date"
                                                        :locale="locale"
                                                        @change="
                                                            fromDateMenu = false
                                                        "
                                                        :max="
                                                            item.to_date || null
                                                        "
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col cols="8" lg="6" class="pl-0 pr-1">
                                                <v-menu
                                                    v-model="toDateMenu"
                                                    :close-on-content-click="
                                                        false
                                                    "
                                                    max-width="290"
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                    >
                                                        <v-text-field
                                                            :value="
                                                                localizeDate(
                                                                    item.to_date
                                                                )
                                                            "
                                                            clearable
                                                            :label="
                                                                translations.to[
                                                                    lang
                                                                ] +
                                                                    translations
                                                                        .date[
                                                                        lang
                                                                    ]
                                                            "
                                                            hide-details="auto"
                                                            readonly
                                                            prepend-inner-icon="mdi-calendar"
                                                            outlined
                                                            dense
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="
                                                                item.to_date =
                                                                    ''
                                                            "
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        dark
                                                        v-model="item.to_date"
                                                        :locale="locale"
                                                        @change="
                                                            toDateMenu = false
                                                        "
                                                        :min="
                                                            item.from_date ||
                                                                null
                                                        "
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                        <v-col
                                            class="d-flex justify-center"
                                            :class="[
                                                !(
                                                    index + 1 ==
                                                    selectedCondition.options
                                                        .length
                                                ) && 'invisible mxh-0'
                                            ]"
                                        >
                                            <v-tooltip color="secondary" top>
                                                <template
                                                    v-slot:activator="{
                                                        on
                                                    }"
                                                >
                                                    <v-btn
                                                        class="text-capitalize"
                                                        depressed
                                                        fab
                                                        v-on="on"
                                                        @click="
                                                            () => {
                                                                selectedCondition.options.push(
                                                                    {
                                                                        to_date:
                                                                            '',
                                                                        from_date:
                                                                            '',
                                                                        campaign_id: null
                                                                    }
                                                                );
                                                            }
                                                        "
                                                    >
                                                        <v-icon
                                                            size="50"
                                                            v-text="
                                                                icons.mdiPlus
                                                            "
                                                        ></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span
                                                    class="font-weight-bold"
                                                    v-text="
                                                        translations.addNew[
                                                            lang
                                                        ]
                                                    "
                                                ></span>
                                            </v-tooltip>
                                        </v-col>
                                    </div>
                                </v-col>
                            </div>
                            <div v-if="selectedCondition.system == 'from_csv'">
                                <v-file-input
                                    color="secondary"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="uploadingFile"
                                    prepend-icon="mdi-file-delimited-outline"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-btn
                                            v-if="fileLoading"
                                            loading
                                            fab
                                            small
                                            icon
                                            class="mt-n2"
                                        ></v-btn>
                                        <v-icon
                                            v-else-if="uploadingFile"
                                            color="green"
                                        >
                                            mdi-check
                                        </v-icon>
                                    </template></v-file-input
                                >
                                <v-checkbox
                                    v-model="
                                        selectedCondition.options.unique_users
                                    "
                                    color="secondary"
                                    class="mt-1 pt-2 no-messages"
                                >
                                    <template v-slot:label>
                                        <h4 class="subtitle-2">
                                            {{
                                                translations.uniqueParticipants[
                                                    lang
                                                ]
                                            }}
                                        </h4>
                                    </template>
                                </v-checkbox>
                            </div>
                        </v-col>
                    </div>
                </v-row>
            </v-card-text>
        </div>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
import {
    mdiArrowLeft,
    mdiArrowRight,
    mdiCalendar,
    mdiCalendarMonth,
    mdiMenuUp,
    mdiMenuDown,
    mdiCellphoneSound,
    mdiPrinterPos,
    mdiStore,
    mdiAndroid,
    mdiApi,
    mdiPlus
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import Places from "@/components/general/Places.vue";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import newCampaign from "../../../store/modules/loyaltyPanel/campaigns/newCampaign";

export default {
    name: "Step3",

    mixins: [translations],

    components: { Places },

    data: () => ({
        icons: {
            mdiArrowLeft,
            mdiArrowRight,
            mdiCalendar,
            mdiCalendarMonth,
            mdiMenuUp,
            mdiMenuDown,
            mdiPlus
        },
        transactionTypesIcons: {
            4: mdiCellphoneSound,
            5: mdiPrinterPos,
            10: mdiStore,
            11: mdiAndroid,
            17: mdiApi
        },
        search: "",
        searchCoupons: "",
        searchProducts: "",
        searchCampaigns: "",
        dates: [],
        address: "",
        center: {},
        markers: [],
        places: [],
        currentPlace: null,
        radius: "1000",
        disableBtn: true,
        page: 1,
        couponsPage: 1,
        productsPage: 1,
        uploadingFile: null,
        fromDateMenu: false,
        toDateMenu: false,
        allStoresAreSelected: false,
        fileLoading: false,
        selectedStores: [],
        selectedStoresData: [],
        selectedCampaigns: [],
        // selectedCampaignsData: []
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "campaignConditions",
            "transactionTypes",
            "products",
            "campaigns",
            "oldCampaigns",
            "coupons",
            "storesPagination",
            "productsPagination",
            "campaignsPagination",
            "stores",
            "canGoToNextStep",
            "step",
            "selectedCampaignsData"
        ]),

        ...mapState(["loading"]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        },
        conditionsWithTranslations() {
            return this.campaignConditions.filter(e => this.translations?.[`${e.system}Condition`]?.[this.lang])
        },
        query() {
            if (this.search) {
                return `?q=${this.search}&page=${this.page}`;
            }

            return `?page=${this.page}`;
        },

        couponsQuery() {
            if (this.searchCoupons) {
                return `?q=${this.searchCoupons}&page=${this.couponsPage}`;
            }

            return `?page=${this.couponsPage}`;
        },

        productsQuery() {
            if (this.searchProducts) {
                return `?q=${this.searchProducts}&page=${this.productsPage}`;
            }

            return `?page=${this.productsPage}`;
        },

        campaignsQuery() {
            if (this.searchCampaigns) {
                return `?q=${this.searchCampaigns}&page=${this.campaignsPage}`;
            }

            return `?page=${this.campaignsPage}`;
        },

        selectedCondition() {
            return (
                (this.campaignConditions || []).find(
                    x =>
                        x.campaign_condition_id ==
                        this.newCampaign.campaign_condition_id
                ) || {}
            );
        },
        remainingCampaigns() {
            if (this.selectedCondition.system !== "from_older_campaign") {
                return [];
            }
            let ids = this.selectedCondition.options.map(e => e.campaign_id);
            return this.oldCampaigns.filter(e => !ids.includes(e.campaign_id));
        },

        storesData(){
            return [...this.stores, ...this.selectedStoresData].map(e => ({...e, disable: this.allStoresAreSelected})).filter(s =>s.store_id)
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "getConditions",
            "getProducts",
            "getOldCampaigns",
            "getCoupons",
            "getStores",
            "uploadFile",
            "getTransactionTypes"
        ]),

        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setNewCampaign",
            "setCanGoToNextStep",
            "setStep",
            "setSelectedCampaignsData"
        ]),
        ...mapMutations(["setErrorMessage"]),

        attachCondition(val) {
            this.$set(
                this.newCampaign,
                "campaign_condition_id",
                val.campaign_condition_id
            );
        },

        localizeDate(date) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                  })
                : "";
        },

        selectTransactionType(val, array) {
            let typeIndex = array.findIndex(x => x == val.transaction_type_id);
            if (typeIndex >= 0) {
                array.splice(typeIndex, 1);
            } else {
                array.push(val.transaction_type_id);
            }
        },

        handleSearch() {
            const body = {
                query: this.query,
                page: this.page
            };
            this.getStores(body);
        },

        handleSearchCoupons() {
            const body = {
                query: this.couponsQuery,
                page: this.couponsPage
            };
            this.getCoupons(body);
        },

        handleSearchProducts() {
            const body = {
                query: this.productsQuery,
                page: this.productsPage
            };
            this.getProducts(body);
        },

        handleSearchCampaigns() {
            const body = {
                q: this.searchCampaigns,
                page: this.campaignsPage
            };
            this.getOldCampaigns(body);
        },

        oldCampaignItemText(item) {
            return `#${item.campaign_id} | ${item.title}`
        },

        loadMoreCoupons() {
            this.couponsPage++;
            const body = {
                query: this.couponsQuery,
                page: this.couponsPage
            };
            this.getCoupons(body);
        },

        loadMoreCampaigns() {
            this.campaignsPage++;
            const body = {
                query: this.campaignsQuery,
                page: this.campaignsPage
            };
            this.getOldCampaigns(body);
        },

        loadMoreProducts() {
            this.productsPage++;
            const body = {
                query: this.productsQuery,
                page: this.productsPage
            };
            this.getProducts(body);
        },

        async loadMoreStores() {
            this.page++;
            const body = {
                query: this.query,
                page: this.page
            };
            await this.getStores(body);
            if (this.allStoresAreSelected) {
                this.stores.map(item => {
                    if (!this.selectedStores.includes(item.store_id)) {
                        this.selectedStores.push(item.store_id);
                    }
                });
            }
        },

        endIntersectStores(entries, observer, isIntersecting) {
            if (
                isIntersecting &&
                this.stores &&
                this.stores.length < this.storesPagination.total
            ) {
                this.loadMoreStores();
            }
        },

        endIntersectProducts(entries, observer, isIntersecting) {
            if (
                isIntersecting &&
                this.products &&
                this.products.length < this.productsPagination.total
            ) {
                this.loadMoreProducts();
            }
        },

        endIntersectCampaigns(entries, observer, isIntersecting) {
            if (
                isIntersecting &&
                this.oldCampaigns &&
                this.oldCampaigns.length < this.campaignsPagination.total
            ) {
                this.loadMoreCampaigns();
            }
        },

        checkValue() {
            this.setCanGoToNextStep(false);
            if (this.selectedCondition.system == "all_clients") {
                this.setCanGoToNextStep(true);
            } 
            if (this.selectedCondition.system == "from_csv") {
                this.setCanGoToNextStep(!!this.newCampaign.campaign_condition_id_options.csv_url);
            }

            if (
                this.selectedCondition.system ==
                "at_least_transactions_certain_stores"
            ) {
                if (
                    this.newCampaign.campaign_condition_id_options.min_amount >
                        0 &&
                    this.newCampaign.campaign_condition_id_options
                        .number_of_transactions_after_campaign > 0 &&
                    (this.allStoresAreSelected ||
                        this.newCampaign.campaign_condition_id_options.store_ids
                            .length > 0) &&
                    this.newCampaign.campaign_condition_id_options
                        .transaction_type_ids.length > 0
                ) {
                    this.setCanGoToNextStep(true);
                }
            }

            if (
                this.selectedCondition.system ==
                "first_transaction_certain_store"
            ) {
                if (
                    this.newCampaign.campaign_condition_id_options.store_id >
                        0 &&
                        (!this.newCampaign.campaign_condition_id_options.min_amount || 
                        this.newCampaign.campaign_condition_id_options.min_amount > 0 )
                ) {
                    this.setCanGoToNextStep(true);
                }
            }

            if (
                this.selectedCondition.system ==
                "acquired_certain_products_certain_stores"
            ) {
                if (
                    (this.allStoresAreSelected ||
                        this.newCampaign.campaign_condition_id_options.store_ids
                            .length > 0) &&
                    this.newCampaign.campaign_condition_id_options.product_ids
                        .length > 0 &&
                    this.newCampaign.campaign_condition_id_options.period
                        .from_date &&
                    this.newCampaign.campaign_condition_id_options.period
                        .to_date
                ) {
                    this.setCanGoToNextStep(true);
                }
            }

            if (this.selectedCondition.system == "from_older_campaign") {
                if (this.newCampaign.campaign_condition_id_options.length) {
                    if (
                        this.newCampaign.campaign_condition_id_options.length >
                            1 &&
                        !this.newCampaign.campaign_condition_id_options[
                            this.newCampaign.campaign_condition_id_options
                                .length - 1
                        ].campaign_id
                    ) {
                        this.newCampaign.campaign_condition_id_options.splice(
                            this.newCampaign.campaign_condition_id_options
                                .length - 1,
                            1
                        );
                    }
                    let isValid = true;
                    this.newCampaign.campaign_condition_id_options.forEach(
                        e => {
                            if (!e.campaign_id) {
                                isValid = false;
                            }
                        }
                    );
                    this.setCanGoToNextStep(isValid);
                }
            }

            if (
                this.selectedCondition.system ==
                "redeemed_coupon_certain_stores"
            ) {
                if (
                    this.newCampaign.campaign_condition_id_options.coupon_ids
                        .length !== 0 &&
                    this.newCampaign.campaign_condition_id_options.period
                        .from_date &&
                    this.newCampaign.campaign_condition_id_options.period
                        .to_date &&
                    (this.allStoresAreSelected ||
                        this.newCampaign.campaign_condition_id_options.store_ids
                            .length > 0)
                ) {
                    this.setCanGoToNextStep(true);
                }
            }

            if (
                this.selectedCondition.system ==
                "x_transactions_certain_stores_after_campaign"
            ) {
                if (
                    this.newCampaign.campaign_condition_id_options
                        .number_of_transactions_after_campaign &&
                    (this.allStoresAreSelected ||
                        this.newCampaign.campaign_condition_id_options.store_ids
                            .length > 0)
                ) {
                    this.setCanGoToNextStep(true);
                }
            }
        },

        clearCampaignIdOnNull(r, i) {
            if (this.selectedCondition.options.length === 1) {
                r.campaign_id = null;
                r.from_date = null;
                r.to_date = null;
            } else if (this.selectedCondition.options.length > 1) {
                this.selectedCondition.options.splice(i, 1);
            }
        },

        saveCampaignData(i, r) {
            if (
                !this.selectedCampaignsData.find(
                    x => x.campaign_id == r.campaign_id
                )
            )
                this.selectedCampaignsData.push(
                    this.oldCampaigns.find(
                        x => x.campaign_id == r.campaign_id
                    ) || {
                        campaign_id: null
                    }
                );
        },
        getCampaignData(r) {
          const campaign = this.selectedCampaignsData.find(x => x.campaign_id === r.campaign_id)
          return campaign ? `#${campaign.campaign_id} | ${campaign.title}` : {}
        },

        setAddressDetails(place) {
            if (place) {
                this.setCanGoToNextStep(true);
            }
            this.currentPlace = place;
            this.isAddress = place.isAddress;
            this.address = place.address;
            this.addMarker();
            this.newCampaign.campaign_condition_id_options.lat = place.lat;
            this.newCampaign.campaign_condition_id_options.lon = place.lon;
        },

        goToNextStep() {
            this.selectedCondition.system == "based_on_location"
                ? (this.newCampaign.campaign_condition_id_options.radius = this.radius)
                : null;
            if (
                [
                    "at_least_transactions_certain_stores",
                    "acquired_certain_products_certain_stores",
                    "redeemed_coupon_certain_stores"
                ].includes(this.selectedCondition.system)
            ) {
                this.newCampaign.campaign_condition_id_options.store_participants =
                    this.newCampaign.campaign_condition_id_options.store_ids
                        .length == this.stores.length
                        ? "*"
                        : "";
            }
            this.$emit("next");
        },
        goToPrevStep() {
            if (this.newCampaign.category == "draw") {
                this.setStep(1);
            } else {
                this.$emit("prev");
            }
        },
        addMarker() {
            if (this.currentPlace) {
                const marker = {
                    lat: this.currentPlace.lat,
                    lng: this.currentPlace.lon
                };
                this.markers = [];
                this.markers.push({ position: marker });
                this.places.push(this.currentPlace);
                this.center = marker;
            }
        },

        geolocate: function() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
            });
        },

        toggleSelectAllStores() {
            if (this.allStoresAreSelected) {
                this.allStoresAreSelected = false;
                this.selectedStores.map((item, index) => {
                    this.selectedStores.splice(
                        index,
                        this.selectedStores.length
                    );
                });
                this.selectedCondition.options.store_participants = "";
            } else {
                this.allStoresAreSelected = true;
                this.stores.map(item => {
                    if (!this.selectedStores.includes(item.store_id)) {
                        this.selectedStores.push(item.store_id);
                    }
                });
                this.selectedCondition.options.store_participants = "*";
            }
        },
        removeSelectedStore(data){
            this.selectedStores.splice(data.index,1)
        }
    },

    mounted() {
        if (this.newCampaign?.campaign_type_id)
                this.getConditions(this.newCampaign.campaign_type_id);
            this.geolocate();
          
            this.newCampaign.campaign_condition_id = this.newCampaign.campaign_condition_id || 1;
            this.newCampaign.campaign_condition_id_options = this.newCampaign.campaign_condition_id_options || {};
      
    },

    watch: {
        ["newCampaign.campaign_type_id"]: {
            immediate: true,
            handler(val) {
                if (val) this.getConditions(val);
            }
        },

        selectedCondition: {
            // immediate: true,
            deep: true,
            handler(val) {
                if (Array.isArray(val.options)) {
                    this.newCampaign.campaign_condition_id_options = [
                        ...val.options
                    ];
                } else {
                    this.newCampaign.campaign_condition_id_options = {
                        ...val.options
                    };
                }
                this.checkValue();
            }
        },

        selectedStores: {
            handler(val) {
                if (!this.allStoresAreSelected) {
                 if (this.selectedCondition.system == 'first_transaction_certain_store') {
                    this.selectedCondition.options.store_id = val[0]
                 }else{
                    this.selectedCondition.options.store_ids = val
                 }
                    this.selectedStoresData.forEach((storeData, i) => {
                        let foundStore = val.find(x => x == storeData?.store_id || 0)
                        if(!foundStore){
                            this.selectedStoresData.splice(i,1)
                        }
                    })
                    val.forEach(id => {
                        let foundId = this.selectedStoresData.find(x => x?.store_id == id)
                        if(!foundId){
                            this.selectedStoresData.push(this.stores.find(x => x?.store_id == id))
                        }
                    })
                  
                }
                
            },
            deep: true
        },
        allStoresAreSelected: {
            handler(val) {
                if (val) {
                    this.selectedOptions.store_ids =  []
                }
            },
            deep: true
        },
        step: {
            immediate: true,
            handler(val) {
                if (val == 3) {
                    this.checkValue();
                }
            }
        },

        ["selectedCondition.system"]: {
            immediate: true,
            handler(val) {
                if (
                    [
                        "at_least_transactions_certain_stores",
                        "first_transaction_certain_store"
                    ].includes(val)
                ) {
                    if (!this.transactionTypes?.length)
                        this.getTransactionTypes();
                    if (!this.stores?.length)
                        this.getStores({
                            query: "",
                            page: 1
                        });
                } else if (val == "acquired_certain_products_certain_stores") {
                    if (!this.stores?.length)
                        this.getStores({
                            query: "",
                            page: 1
                        });
                    if (!this.products?.length)
                        this.getProducts({
                            query: "",
                            page: 1
                        });
                } else if (val == "from_older_campaign") {
                    // if (!this.campaigns?.length)
                    //     this.getOldCampaigns({
                    //         query: "",
                    //         page: 1
                    //     });
                } else if (val == "redeemed_coupon_certain_stores") {
                    if (!this.stores?.length)
                        this.getStores({
                            query: "",
                            page: 1
                        });
                    if (!this.coupons?.length)
                        this.getCoupons({
                            query: "",
                            page: 1
                        });
                } 
                if (val != 'all_clients') {
                        this.$nextTick(() => {
                            this.$vuetify.goTo("#conditions", {
                                duration: 300,
                                offset: 50,
                                easing: "easeInOutCubic"
                            });
                        });
                    }
            }
        },

        search() {
            this.page = 1;
            this.debouncedSearch();
        },

        searchCoupons() {
            this.couponsPage = 1;
            this.debouncedSearchCoupons();
        },

        searchProducts() {
            this.productsPage = 1;
            this.debouncedSearchProducts();
        },

        searchCampaigns() {
            this.campaignsPage = 1;
            this.debouncedSearchCampaigns();
        },

        async uploadingFile(val) {
            this.fileLoading = true;
            this.setCanGoToNextStep(false);
            if (val) {
                let extension = val.name
                    .substr(val.name.lastIndexOf(".") + 1)
                    .toLowerCase();
                if (
                    extension == "xls" ||
                    extension == "csv" ||
                    extension == "xlsx"
                ) {
                    let response = await this.uploadFile(val);
                    this.fileLoading = false;
                    if (response.error) {
                        this.uploadingFile = null;
                        return;
                    }
                    if (response.data.csv_url){
                        this.selectedCondition.options.csv_url = response.data.csv_url
                    }
                }
            }
            this.fileLoading = false;
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
        this.debouncedSearchCoupons = debounce(this.handleSearchCoupons, 500);
        this.debouncedSearchProducts = debounce(this.handleSearchProducts, 500);
        this.debouncedSearchCampaigns = debounce(this.handleSearchCampaigns, 500);
    }
};
</script>

<style>
.no-messages .v-messages {
    display: none;
}

.campaign-actions.conditions-loader .v-skeleton-loader__actions {
    height: 64px;
    padding: 0;
}
.campaign-actions.conditions-loader .v-skeleton-loader__button {
    border-radius: 24px;
}

.v-list-item--disabled {
 opacity: 0.7;
}
</style>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
    /* margin-top:20px; */
    height: 200px;
    width: 200px;
}
.select-category {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 200px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}
.select-category:hover {
    /* background-color: rgba(0, 0, 0, 0.2); */
    background-color: #27272730;
    color: black;
    border-color: black;
    /* font-size: 26px; */
}

.invisible {
    opacity: 0;
    z-index: -1;
}

.overlapped {
    position: absolute;
}

.transition-all {
    transition: all 1s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s;
}
.back-button {
    position: absolute;
    top: 45%;
    z-index: 10;
}
.mw-100 {
    min-width: 100% !important;
}
.mw-180 {
    min-width: 180px !important;
}

.mxh-0 {
    max-height: 0 !important;
}
.mxh-0 * {
    max-height: 0 !important;
}

.select-transaction-type {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 80px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}
.select-transaction-type:hover {
    /* background-color: rgba(0, 0, 0, 0.2); */
    background-color: #27272730;
    color: black;
    border-color: black;
    /* font-size: 26px; */
}

.selected-condition {
    color: white;
    background: #272727;
    border-color: #272727;
}

.selected-condition .v-icon {
    background: white;
    color: #272727;
}
.selected-condition .border-grey {
    border-color: #272727;
}

</style>
